import './SecurityContentStyles.css'


import React from 'react'

const SecurityContent = () => {
  return (
    <div>
      <div className="container-fluid work ">
        <div className="row py-5">
          <div className="col-2"></div>
            <div className="col-lg-8 col-md-8 col-sm-8 col-8 text-center pt-lg-4 pt-md-2 pt-sm-0 pt-0">
              <p>Our security officers can work day shifts, night shifts, weekends, and public holidays so to keep them happy we plan their schedules to give them quality time away from the workplace. This means that when they return, they are fresh and focused.</p>
            </div>
          <div className="col-2"></div>
        </div>
      </div>
    </div>
  )
}

export default SecurityContent
